import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Navbar as BootstrapNavbar } from "react-bootstrap";
import "./styles.scss";

const Navbar = ({ className, children, ...rest }) => {
  return (
    <BootstrapNavbar
      className={classNames("mydpd-navbar", className)}
      {...rest}
      collapseOnSelect
      expand="lg"
    >
      {children}
    </BootstrapNavbar>
  );
};

Navbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  ...BootstrapNavbar.propTypes,
};

export default Navbar;
